import "./DetailForm.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import baseUrl from "../../url/baseUrl";

// Tạo form lựa chọn kích cỡ và số lượng để thêm vào cart
const DetailForm = (props) => {
  const navigate = useNavigate();

  const [inputQuan, setInputQuan] = useState("");
  const [inputSize, setInputSize] = useState("");

  const isLogin = useSelector((state) => state.loginUser.isLogin);

  // method xử lý chọn số lượng
  const handleChange = (e) => {
    setInputQuan(e.target.value);
  };

  // method xử lý chọn kích cỡ
  const handleChangeRadio = (e) => {
    setInputSize(e.target.value);
  };

  // Add cart với người dùng không đăng nhập
  const addToCartWithoutLogin = (e) => {
    e.preventDefault();
    const cart = JSON.parse(localStorage.getItem("unLogCart")) || [];

    if (inputQuan < 1 || !inputSize) {
      alert("Vui lòng chọn số lượng và kích cỡ sản phẩm!");
      return;
    }

    if (inputQuan > props.product.count) {
      alert("Sản phẩm order vượt quá số lượng trong kho!");
      return;
    }

    // Tìm index của sản phẩm cần thêm trong giỏ hàng
    const cartProductIndex = cart.findIndex((cp) => {
      return cp.productId === props.product._id && cp.sizeInfo === inputSize;
    });

    let newQuantity;
    const updatedCartItems = [...cart];

    // Nếu sp đã có trong giỏ hàng => chỉ tăng số lượng + update tổng giá
    if (cartProductIndex >= 0) {
      newQuantity = cart[cartProductIndex].quantity + +inputQuan;
      updatedCartItems[cartProductIndex].quantity = newQuantity;
      updatedCartItems[cartProductIndex].totalPriceOfProduct =
        +updatedCartItems[cartProductIndex].price * newQuantity;
      // Lưu thông tin mới vào localStorage
      localStorage.setItem("unLogCart", JSON.stringify(updatedCartItems));
      navigate("/cart");
      // nếu chưa có trong giỏ hàng => thêm mới thông tin sản phẩm
    } else {
      // Khởi tạo đối tượng mới
      const productAdd = {
        _id: Math.random() * 1000000000,
        productId: props.product._id,
        quantity: +inputQuan,
        sizeInfo: inputSize,
        name: props.product.name,
        price: props.product.price,
        img: props.product.img1,
        totalPriceOfProduct: props.product.price * +inputQuan,
      };
      cart.push(productAdd);
      localStorage.setItem("unLogCart", JSON.stringify(cart));
      navigate("/cart");
    }
  };

  // Add cart với người dùng đã đăng nhập
  const addToCart = async (e) => {
    e.preventDefault();

    if (inputQuan < 1 || !inputSize) {
      alert("Vui lòng chọn số lượng và kích cỡ sản phẩm!");
      return;
    }

    if (inputQuan > props.product.count) {
      alert("Sản phẩm order vượt quá số lượng trong kho!");
      return;
    }

    // Khởi tạo đối tượng mới
    const productAdd = {
      quantity: +inputQuan,
      sizeInfo: inputSize,
      productId: props.product._id,
    };

    try {
      const response = await fetch(baseUrl + "/add-to-cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        credentials: "same-origin",
        mode: "cors",

        body: JSON.stringify(productAdd),
      });

      if (response.status === 404) {
        throw new Error("Không tìm thấy User hoặc sản phẩm.");
      }

      if (response.status !== 200) {
        alert("Vui lòng đăng nhập để order.");
        return;
      }

      navigate("/cart");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form onSubmit={isLogin ? addToCart : addToCartWithoutLogin}>
      <p className="text-success text-uppercase mb-0">Chọn kích cỡ sản phẩm</p>
      <div className="mb-2">
        {props.product.detail.size.map((size, i) => {
          return (
            <div key={i}>
              <input
                type="radio"
                id={`${props.product.name} size-${size}`}
                value={size}
                name={props.product.name}
                className="me-2"
                onChange={handleChangeRadio}
              />
              <label
                className="text-info fst-italic"
                htmlFor={`${props.product.name} size-${size}`}
              >
                {size}
              </label>
            </div>
          );
        })}
      </div>

      <div className="detail_form_wrap">
        <div className="vertical-center">
          <p
            className="text-uppercase mb-0 text-muted"
            style={{ wordSpacing: "-1px" }}
          >
            Số lượng
          </p>
        </div>
        <input
          type="number"
          name="quantity"
          min="1"
          value={inputQuan}
          onChange={handleChange}
          placeholder="0"
        />
        <div>
          <button
            className="bg-success text-light text-uppercase"
            type="submit"
            style={{ wordSpacing: "-2px" }}
          >
            Thêm vào giỏ
          </button>
        </div>
      </div>
    </form>
  );
};

export default DetailForm;
